import { render, staticRenderFns } from "./VersionLabelDialog.vue?vue&type=template&id=096a95fb&scoped=true"
import script from "./VersionLabelDialog.vue?vue&type=script&lang=ts"
export * from "./VersionLabelDialog.vue?vue&type=script&lang=ts"
import style0 from "./VersionLabelDialog.vue?vue&type=style&index=0&id=096a95fb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096a95fb",
  null
  
)

export default component.exports